import React from 'react';

import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';

import { getCookie, setCookie, deleteCookie } from 'lib/cookies';

// mixin
const sizes = css`
  width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
  height: ${({ customheight }) => customheight !== null && customheight + 'px'};
`;

// Modal styling
const CustomModal = styled(Modal)`
  .modal-dialog {
    ${sizes}

    .modal-content {
      ${sizes}

      .modal-body {
        position: relative;
        display: table;
        padding: 0;

        img {
          max-width: ${({ customwidth }) =>
            customwidth !== null && customwidth + 'px'};
          max-height: ${({ customheight }) =>
            customheight !== null && customheight + 'px'};
        }
      }
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: ${({ customwidth }) =>
        customwidth !== null && customwidth + 'px'};
      margin: 1.75rem auto;
    }
  }
`;

const CheckboxToDisable = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2% 3%;
  background-color: #ffffff;
  user-select: none;
  font-size: 14px;
  background-color: whitesmoke;
  position: absolute;
  bottom: 0;
  width: 100%;

  .check-disable {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    visibility: hidden;

    input[type='checkbox'] {
      border: 1px solid #8898aa;
      width: 12px;
      height: 12px;
    }

    input[type='checkbox']::checked {
      background-color: #8898aa;
    }

    label {
      margin: 0;
      margin-left: 5px;
      font-size: 13px;
      color: #8898aa;
    }
  }

  .check-disable.show {
    visibility: visible;
  }

  .close-popup {
    cursor: pointer;
    font-size: 14px;
    /* color: #8898aa; */
  }
`;

function PopUp({
  popupId,
  showPopUp,
  setShowPopUp,
  content,
  time,
  width,
  height,
  link,
}) {
  const checkDisablePopup = (popupIdx) => {
    const newChecked = [...showPopUp];
    const currentIndex = newChecked.indexOf(popupId);

    if (currentIndex !== -1) {
      newChecked.splice(currentIndex, 1);
    } else {
      newChecked.push(popupIdx);
    }

    setShowPopUp(newChecked);
  };

  const checkedToDisablePopup = (event) => {
    const isCheckedOrNot = event.target.checked;
    if (isCheckedOrNot) {
      if (getCookie(`${process.env.REACT_APP_COOKIE_NAME}_p_${popupId}`)) {
        return;
      } else {
        setCookie(
          `${process.env.REACT_APP_COOKIE_NAME}_p_${popupId}`,
          'disabled_show',
          { 'max-age': 60 * 60 * time }
        );
      }
    } else {
      if (getCookie(`${process.env.REACT_APP_COOKIE_NAME}_p_${popupId}`)) {
        deleteCookie(`${process.env.REACT_APP_COOKIE_NAME}_p_${popupId}`);
      } else {
        return;
      }
    }
  };

  return showPopUp.indexOf(popupId) === -1 ? (
    <CustomModal
      centered
      show={showPopUp}
      onHide={() => checkDisablePopup(popupId)}
      animation={false}
      customwidth={width > 0 && width !== null ? width : null}
      customheight={height > 0 && height !== null ? height : null}
    >
      {link ? (
        <Modal.Body>
          <a target="_blank" href={link}>
            <img src={`${process.env.REACT_APP_URI}/${content}`} alt="" />
          </a>
          <CheckboxToDisable>
            <div className={`check-disable ${time > 0 && 'show'}`}>
              <input
                type="checkbox"
                id="closeChk"
                onChange={checkedToDisablePopup}
              />
              <label htmlFor="closeChk">{time}시간동안 닫습니다.</label>
            </div>
            <span
              className="close-popup"
              onClick={() => checkDisablePopup(popupId)}
            >
              닫기
            </span>
          </CheckboxToDisable>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <img src={`${process.env.REACT_APP_URI}/${content}`} alt="" />
          <CheckboxToDisable>
            <div className={`check-disable ${time > 0 && 'show'}`}>
              <input
                type="checkbox"
                id="closeChk"
                onChange={checkedToDisablePopup}
              />
              <label htmlFor="closeChk">{time}시간동안 닫습니다.</label>
            </div>
            <span
              className="close-popup"
              onClick={() => checkDisablePopup(popupId)}
            >
              닫기
            </span>
          </CheckboxToDisable>
        </Modal.Body>
      )}
    </CustomModal>
  ) : null;
}

export default PopUp;
